<template>
  <div>
    <hr />

    <!-- Instrucciones -->
<!--
    <div class="alert alert-info py-2 px-3 mb-3" role="alert">
      <strong>Instrucciones:</strong>
      Escriba y presione <kbd>Enter</kbd> en los campos de texto.
      Seleccione una opción en las listas desplegables para filtrar automáticamente.
    </div>
-->

    <!-- Bloque de búsqueda -->
    <div class="container mb-4">
      <div class="row g-3 align-items-end">

        <!-- Descripción -->
        <div class="col-auto">
          <label class="form-label fw-bold">Descripción Prestador</label>
          <input
            type="text"
            class="form-control"
            v-model="descripcionBusqueda"
            @keyup.enter="getDataDescripcion(1)"
            placeholder="Ej. CONSULTA"
            style="width: 200px; text-transform: uppercase"
          />
        </div>

        <!-- Clasificación -->
        <div class="col-auto">
          <label class="form-label fw-bold">Clasificación</label>
          <select
            class="form-select"
            v-model="clasificacionBusqueda"
            @change="getDataClasificacion(1)"
            style="width: 160px"
          >
            <option value="" disabled selected>Seleccione...</option>
            <option value="2">TPSNS</option>
            <option value="10">Medicamentos</option>
            <option value="11">Insumos</option>
          </select>
        </div>

        <!-- Código TPSNS -->
        <div class="col-auto">
          <label class="form-label fw-bold">Código TPSNS</label>
          <input
            type="text"
            class="form-control"
            v-model="codigoBusqueda"
            @keyup.enter="getDataCodigo(1)"
            placeholder="Ej. A001"
            style="width: 160px; text-transform: uppercase"
          />
        </div>

        <!-- Elemento TPSNS -->
        <div class="col-auto">
          <label class="form-label fw-bold">Descripción TPSNS</label>
          <input
            type="text"
            class="form-control"
            v-model="nombreBusqueda"
            @keyup.enter="getDataNombre(1)"
            placeholder="Buscar elemento..."
            style="width: 300px; text-transform: uppercase"
          />
        </div>

        <!-- Botón Todos -->
        <div class="col-auto">
          <button
            type="button"
            class="btn btn-outline-primary"
            @click.prevent="getDataPaginaTodos(1, 0)"
            title="Todos los registros"
          >
            <i class="material-icons me-1">auto_awesome_motion</i>
          </button>
        </div>

        <!-- Botón Nuevo -->
        <div class="col-auto" v-if="auditoriaMedica">
          <button
            type="button"
            class="btn btn-outline-success"
            @click="abrirModalCrear"
            title="Nuevo registro"
          >
            <i class="material-icons me-1">add_box</i>
          </button>
        </div>

      </div>
    </div>

    <!-- Selector registros por página -->
    <div class="d-flex justify-content-end align-items-center gap-2 mb-2" v-if="planilladets.length > 0">
        <!-- Botón CSV -->
        <div class="col-auto" v-if="auditoriaMedica">
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="exportToCSV"
            title="Exportar CSV"
          >
            <span class="material-icons me-1" style="font-size: 16px;">download</span>CSV
          </button>
        </div>

        <!-- Botón XLSX -->
        <div class="col-auto" v-if="auditoriaMedica">
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="exportToExcel"
            title="Exportar Excel"
          >
            <span class="material-icons me-1" style="font-size: 16px;">download</span>XLSX
          </button>
        </div>

<div class="col-auto" v-if="auditoriaMedica && haySeleccionados">
  <button
    type="button"
    class="btn btn-outline-danger"
    @click="borrarSeleccionados"
    title="Borrar seleccionados"
  >
    <span class="material-icons me-1" style="font-size: 16px;">delete</span>
    Borrar ({{ seleccionados.length }})
  </button>
</div>
      <label class="form-label mb-0 small fw-bold">Mostrar</label>
      <select
        v-model="elementosPorPagina"
        class="form-select form-select-sm"
        style="width: 75px"
        @change="updateItemsPerPage"
      >
        <option :value="5">5</option>
        <option :value="10">10</option>
        <option :value="25">25</option>
        <option :value="100">100</option>
        <option :value="100000000">Todos</option>
      </select>
      <span class="small text-muted">registros</span>
    </div>

    <!-- Tabla -->
    <div class="table-responsive" v-if="planilladets.length > 0">
      <table id="sampleTable" class="table table-hover table-bordered table-sm">
<thead class="table-dark">
  <!-- Fila 1: encabezados ordenables -->
  <tr>
    <th></th>
    <th class="th-sort" @click="ordenarPor('fechaAtencion')">
      Fecha <span>{{ iconOrden('fechaAtencion') }}</span>
    </th>
    <th class="th-sort" @click="ordenarPor('elementoCodigo')">
      Código TPSNS <span>{{ iconOrden('elementoCodigo') }}</span>
    </th>
    <th class="th-sort" @click="ordenarPor('elementoNombre')">
      Elemento TPSNS <span>{{ iconOrden('elementoNombre') }}</span>
    </th>
    <th style="text-align:right" class="th-sort" @click="ordenarPor('cantidad')">
      Cantidad <span>{{ iconOrden('cantidad') }}</span>
    </th>
    <th style="text-align:right" class="th-sort" @click="ordenarPor('valorUni')">
      Valor Unitario <span>{{ iconOrden('valorUni') }}</span>
    </th>
    <th style="text-align:right">Valor Total</th>
    <th v-if="auditoriaMedica" style="text-align:right">Lab.</th>
    <th v-if="auditoriaMedica" style="text-align:right">Img.</th>
    <th v-if="auditoriaMedica">Opciones</th>
<th v-if="auditoriaMedica" class="text-center">
  <input
    type="checkbox"
    :checked="todosSeleccionadosEnPagina"
    @change="toggleSeleccionarTodos"
  />
</th>
  </tr>

  <!-- Fila 2: filtros por columna -->
  <tr>
    <th></th>
    <th>
      <input
        type="date"
        v-model="filtroFechaAtencion"
        @change="_aplicarSlice(1)"
        class="form-control form-control-sm"
      />
    </th>
    <th>
      <input
        v-model="filtroCodigoTPSNS"
        @input="_aplicarSlice(1)"
        class="form-control form-control-sm"
        placeholder="Filtrar..."
      />
    </th>
    <th>
      <input
        v-model="filtroNombreTPSNS"
        @input="_aplicarSlice(1)"
        class="form-control form-control-sm"
        placeholder="Filtrar..."
      />
    </th>
    <th></th>
    <th></th>
    <th></th>
    <th v-if="auditoriaMedica"></th>
    <th v-if="auditoriaMedica"></th>
    <th v-if="auditoriaMedica"></th>
    <th v-if="auditoriaMedica"></th>
  </tr>
</thead>
        <tbody>
          <tr
            v-for="planilladet in datosPaginados"
            :key="planilladet.idPlanillaDet"
            @dblclick="handleRowClick($event, planilladet.idPlanillaDet)"
            :class="{ 'table-warning': planilladet.revisado == 1 }"
            title="Doble clic para visualizar los detalles completos del registro"
          >
            <td class="text-center">
              <span
                class="material-symbols-outlined"
                style="font-size: 24px; color: green; cursor: pointer"
                role="button"
                @click.prevent="actualizarRevision(planilladet, planilladet.revisado)"
                title="Marcar como revisado"
              >
                {{ planilladet.revisado == 1 ? 'check_box' : 'check_box_outline_blank' }}
              </span>
            </td>
            <td>{{ getFormattedDate(planilladet.fechaAtencion) }}</td>
            <td>{{ planilladet.elementoCodigo }}</td>
            <td>{{ planilladet.elementoNombre }}</td>
            <td style="text-align: right">{{ planilladet.cantidad }}</td>
            <td style="text-align: right">{{ planilladet.valorUni }}</td>
            <td style="text-align: right">{{ planilladet.cantidad * planilladet.valorUni }}</td>
            <td v-if="auditoriaMedica" style="text-align: right">
              <span
                v-if="planilladet.laboratorio == 1"
                title="Actualizar fecha en elementos de laboratorios"
                @click="actualizarFechaLab(planilladet.idPlanilla, planilladet.idPlanilla, planilladet.fechaAtencion)"
                style="cursor: pointer"
              >
                <span class="material-symbols-outlined" style="font-size: 24px; color: green;">date_range</span>
              </span>
            </td>
            <td v-if="auditoriaMedica" style="text-align: right">
              <span
                v-if="planilladet.imagen == 1"
                class="btn btn-sm btn-outline-primary d-inline-flex align-items-center justify-content-center"
                title="Actualizar fecha en imágenes"
                style="width: 40px; height: 40px; cursor: pointer;"
                @click="actualizarFechaLab(planilladet.idPlanilla, planilladet.idPlanilla, planilladet.fechaAtencion)"
              >
                <span class="material-symbols-outlined" style="font-size: 24px; color: white;">date_range</span>
              </span>
            </td>
            <td v-if="auditoriaMedica">
              <select
                class="form-select form-select-sm"
                @change="handleAction($event, planilladet.idPlanillaDet)"
              >
                <option disabled selected>Seleccione...</option>
                <option value="editar" v-if="p_estadoTramite === 'RECIBIDO'">Editar</option>
                <option value="observaciones">Observaciones</option>
                <option value="observacionesF">Obs. Financiador</option>				
                <option v-if="idPerfil == 16 || 1 == 1" value="borrar">Borrar</option>
              </select>
            </td>
<td v-if="auditoriaMedica" class="text-center">
  <input
    type="checkbox"
    :checked="seleccionados.includes(planilladet.idPlanillaDet)"
    @click.stop
    @change="toggleSeleccion(planilladet.idPlanillaDet)"
  />
</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td colspan="5" class="text-end fw-bold small"><strong>Total:</strong></td>
            <td class="text-end fw-bold small"><strong>{{ contarRegistros }}</strong></td>
            <td></td>
            <td class="text-end fw-bold small"><strong>{{ calcularTotal }}</strong></td>
            <td v-if="auditoriaMedica"></td>
            <td v-if="auditoriaMedica"></td>
            <td v-if="auditoriaMedica">
              <span class="small text-muted">
                Mostrando {{ datosPaginados.length }} de {{ planilladets.length }} registros
              </span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Sin resultados -->
    <div v-if="planilladets.length === 0" class="alert alert-warning mt-3" role="alert">
      No se recuperaron registros.
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3" v-if="planilladets.length > 0">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ planilladets.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="fetchDataWithFilters(1)">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage">‹</a>
          </li>
          <li
            v-for="pagina in paginasVisibles"
            :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual, disabled: pagina === '...' }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="pagina !== '...' && fetchDataWithFilters(pagina)"
            >{{ pagina }}</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="fetchDataWithFilters(totalPaginas())">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size: 24px; color: white">info</span>
            <h5 class="modal-title text-white ms-2" id="exampleModalLabel">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Código</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPlanillaDet.codigo" disabled />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Descripción</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPlanillaDet.descripcion" disabled />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Código Estándar</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPlanillaDet.elementoCodigo" disabled />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Descripción Estándar</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPlanillaDet.elementoNombre" disabled />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Fecha de Atención</label></div>
                  <div class="col-2">
                    <input
                      type="date"
                      class="form-control"
                      v-model="datoPlanillaDet.fechaAtencion"
                      :min="getFormattedDateISO(p_fechaDesde)"
                      :max="getFormattedDateISO(p_fechaHasta)"
                    />
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Cantidad</label></div>
                  <div class="col-2">
                    <input type="number" class="form-control" v-model="datoPlanillaDet.cantidad" required />
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Valor unitario</label></div>
                  <div class="col-2">
                    <input type="number" class="form-control" v-model="datoPlanillaDet.valorUni" disabled />
                  </div>
                </div>
              </div>
              <hr />

              <!-- Tabla de equivalencia -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Tabla de equivalencia</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoPlanillaDet.idElemento">
                      <option
                        v-for="elemento in elementosPrestador"
                        :value="elemento.idElemento"
                        :key="elemento.idElemento"
                      >
                        {{ elemento.elementoCodigo }} - {{ elemento.elementoNombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Elementos del tarifario -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Elementos del tarifario</label></div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchTextTarifario"
                      @input="debouncedFilterTarifario"
                      placeholder="Buscar en tarifario..."
                    />
                  </div>
                </div>
              </div>
              <div v-if="filteredTarifario.length > 0" class="result-container mb-3">
                <div class="table-responsive">
                  <table class="table table-hover table-bordered table-sm">
                    <thead class="table-dark">
                      <tr>
                        <th>Código</th>
                        <th>Nombre</th>
                        <th>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="tarifa in paginatedTarifario"
                        :key="tarifa.idTarifa"
                        @click="selectTarifario(tarifa)"
                        style="cursor: pointer"
                      >
                        <td>{{ tarifa.elementoCodigo }}</td>
                        <td>{{ tarifa.elementoNombre }}</td>
                        <td>{{ tarifa.valor }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-2">
                  <div>
                    <button type="button" class="btn btn-outline-primary btn-sm me-2"
                      :disabled="currentPageTarifario === 1" @click="currentPageTarifario--">‹ Anterior</button>
                    <button type="button" class="btn btn-outline-primary btn-sm"
                      :disabled="currentPageTarifario === totalPagesTarifario" @click="currentPageTarifario++">Siguiente ›</button>
                  </div>
                  <span class="small text-muted">Página {{ currentPageTarifario }} de {{ totalPagesTarifario }}</span>
                </div>
              </div>

              <!-- Todos los elementos codificados -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Todos los elementos codificados</label></div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchTextElemento"
                      @input="debouncedFilterElementos"
                      placeholder="Buscar elemento..."
                    />
                  </div>
                </div>
              </div>
              <div v-if="filteredElementos.length > 0" class="result-container mb-3">
<div class="table-responsive">
  <table class="table table-hover table-bordered table-sm">
    <thead class="table-dark">
      <!-- Fila 1: encabezados ordenables -->
      <tr>
        <th class="th-sort" @click="ordenarPorElemento('clasElemNombre')">
          Tipo <span>{{ iconOrdenElemento('clasElemNombre') }}</span>
        </th>
        <th class="th-sort" @click="ordenarPorElemento('codigo')">
          Código <span>{{ iconOrdenElemento('codigo') }}</span>
        </th>
        <th class="th-sort" @click="ordenarPorElemento('nombre')">
          Nombre <span>{{ iconOrdenElemento('nombre') }}</span>
        </th>
      </tr>
      <!-- Fila 2: filtros por columna -->
      <tr>
        <th>
          <input
            v-model="filtroTipoElemento"
            class="form-control form-control-sm"
            placeholder="Filtrar..."
            @click.stop
          />
        </th>
        <th>
          <input
            v-model="filtroCodigoElemento"
            class="form-control form-control-sm"
            placeholder="Filtrar..."
            @click.stop
          />
        </th>
        <th>
          <input
            v-model="filtroNombreElemento"
            class="form-control form-control-sm"
            placeholder="Filtrar..."
            @click.stop
          />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="elemento in paginatedElementos"
        :key="elemento.idElemento"
        @click="selectElemento(elemento)"
        style="cursor: pointer"
      >
        <td :style="{ backgroundColor: elemento.color }">{{ elemento.clasElemNombre }}</td>
        <td>{{ elemento.codigo }}</td>
        <td>{{ elemento.nombre }}</td>
      </tr>
    </tbody>
  </table>
</div>
                <div class="d-flex justify-content-between align-items-center mt-2">
                  <div>
                    <button type="button" class="btn btn-outline-primary btn-sm me-2"
                      :disabled="currentPage === 1" @click="currentPage--">‹ Anterior</button>
                    <button type="button" class="btn btn-outline-primary btn-sm"
                      :disabled="currentPage === totalPages" @click="currentPage++">Siguiente ›</button>
                  </div>
                  <span class="small text-muted">Página {{ currentPage }} de {{ totalPages }}</span>
                </div>
              </div>

            </div><!-- /modal-body -->
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarPlanillaDet"
              v-if="btnCrear"
              title="Guardar"
            >
              <i class="material-icons me-1" style="font-size: 20px; vertical-align: middle">save</i>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarPlanillaDet"
              v-if="btnEditar && (p_procesoAM)"
              title="Actualizar"
            >
              <i class="material-icons me-1" style="font-size: 20px; vertical-align: middle">update</i>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Modal -->
  <div v-if="modalObsVisible" class="modal-overlay" @click.self="cerrarModal">
    <div class="modal-contenido card shadow-lg">
      <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center py-2">
        <span class="fw-bold small">
          <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">
            assignment
          </span>
          Observaciones — Planilla {{ planillaDetSeleccionada }}
        </span>
        <button class="btn btn-sm btn-outline-light" @click="cerrarModal">
          <span class="material-symbols-outlined" style="font-size: 16px;">close</span>
        </button>
      </div>
      <div class="card-body p-2" style="max-height: 70vh; overflow-y: auto;">
        <PlanillaDetObs :idPlanillaDet="planillaDetSeleccionada" />
      </div>
    </div>
  </div>
  
</template>

<script>
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import * as bootstrap from "bootstrap";
import swal from "sweetalert";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import PlanillaDetObs from "@/views/reportes/PlanillaDetObs.vue";

export default {
  props: {
    p_idTramite:    { type: Number,  required: true },
    p_idPrestador:  { type: Number,  required: true },
    p_estadoTramite:{ type: String,  required: true },
    p_idPlanilla:   { type: Number,  required: true },
    p_numero:       { type: String,  required: true },
    p_fechaDesde:   { type: Date,    required: true },
    p_fechaHasta:   { type: Date,    required: true },
    p_tipo:         { type: String,  required: true },
    p_procesoAM:    { type: Boolean, required: true },
    p_tipoConsulta: { type: String,  required: true },
  },
  components: {
    PlanillaDetObs,
  },
  data() {
    return {
      planilladets:          [],
      datoPlanillaDet:       {},
      nombreBusqueda:        "",
      descripcionBusqueda:   "",
      codigoBusqueda:        "",
      clasificacionBusqueda: "",
      titulo:                "",
      btnCrear:              false,
      btnEditar:             false,
      elementosPorPagina:    10,
      datosPaginados:        [],
      paginaActual:          1,
      modalWindow:           false,
      elementosPrestador:    [],
      elementos:             [],
      idPerfil:              0,
      idUsuario:             0,
      showDropdownElemento:  false,
      searchTextElemento:    "",
      filteredElementos:     [],
      debounceTimer:         null,
      currentPage:           1,
      itemsPerPage:          5,
      modalInstance:         null,
      searchTextTarifario:   "",
      filteredTarifario:     [],
      currentPageTarifario:  1,
      itemsPerPageTarifario: 5,
      debounceTimerTarifario:null,
      modalObsVisible:         false,
      planillaDetSeleccionada: null,
      // Ordenamiento
      campoOrden: 'fechaAtencion',
      ascendente:              false,
      // Filtros por columna
      filtroFechaAtencion: '',
      filtroCodigoTPSNS:   '',
      filtroNombreTPSNS:   '',
      verReportes: 0,
      seleccionados: [],
      // Orden y filtro para tabla de elementos
      campoOrdenElemento: 'nombre',
      ascendenteElemento: true,
      filtroTipoElemento:   '',
      filtroCodigoElemento: '',
      filtroNombreElemento: '',
    };
  },
  computed: {
    auditoriaMedica() {
      return (
        ( (this.idPerfil == 16 || this.idPerfil == 17 || this.idPerfil == 18) ||
          ( this.verReportes > 0 ) ) &&
        (this.p_estadoTramite === "RECIBIDO"   ||
         this.p_estadoTramite === "EN PROCESO" ||
         this.p_estadoTramite === "PLANILLAJE")
      );
    },
    supervisorGD() {
      return (
        this.idPerfil == 19 &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    contarRegistros() {
      return this.planilladets.length;
    },
    calcularTotal() {
      return this.planilladets
        .reduce((total, p) => total + p.cantidad * p.valorUni, 0)
        .toFixed(2);
    },
  paginatedElementos() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    return this.elementosOrdenados.slice(start, start + this.itemsPerPage);
  },
  totalPages() {
    return Math.ceil(this.elementosOrdenados.length / this.itemsPerPage);
  },
    paginatedTarifario() {
      const start = (this.currentPageTarifario - 1) * this.itemsPerPageTarifario;
      return this.filteredTarifario.slice(start, start + this.itemsPerPageTarifario);
    },
    totalPagesTarifario() {
      return Math.ceil(this.filteredTarifario.length / this.itemsPerPageTarifario);
    },
    // ── Páginas visibles con puntos suspensivos (igual que Tramites) ──
    paginasVisibles() {
      const total  = this.totalPaginas();
      const actual = this.paginaActual;
      const delta  = 2;
      const rango  = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift('...');
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push('...');
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },
planillaOrdenada() {
  const campo = this.campoOrden;

  // Filtros
  let lista = this.planilladets.filter(p => {
    const fec = this.filtroFechaAtencion
      ? (p.fechaAtencion ?? '').slice(0, 10) === this.filtroFechaAtencion
      : true;
    const cod = this.filtroCodigoTPSNS
      ? String(p.elementoCodigo ?? '').toLowerCase()
          .includes(this.filtroCodigoTPSNS.toLowerCase())
      : true;
    const nom = this.filtroNombreTPSNS
      ? String(p.elementoNombre ?? '').toLowerCase()
          .includes(this.filtroNombreTPSNS.toLowerCase())
      : true;
    return fec && cod && nom;
  });

  // Ordenamiento
  return lista.sort((a, b) => {
    let va = a[campo] ?? '';
    let vb = b[campo] ?? '';
    const cmp = typeof va === 'number'
      ? va - vb
      : String(va).localeCompare(String(vb), 'es');
    return this.ascendente ? cmp : -cmp;
  });
},
  todosSeleccionadosEnPagina() {
    return this.datosPaginados.length > 0 &&
      this.datosPaginados.every(p => this.seleccionados.includes(p.idPlanillaDet));
  },
  haySeleccionados() {
    return this.seleccionados.length > 0;
  },
  elementosOrdenados() {
    let lista = this.filteredElementos.filter(e => {
      const tipo = this.filtroTipoElemento
        ? String(e.clasElemNombre ?? '').toLowerCase()
            .includes(this.filtroTipoElemento.toLowerCase())
        : true;
      const cod = this.filtroCodigoElemento
        ? String(e.codigo ?? '').toLowerCase()
            .includes(this.filtroCodigoElemento.toLowerCase())
        : true;
      const nom = this.filtroNombreElemento
        ? String(e.nombre ?? '').toLowerCase()
            .includes(this.filtroNombreElemento.toLowerCase())
        : true;
      return tipo && cod && nom;
    });

    const campo = this.campoOrdenElemento;
    return lista.sort((a, b) => {
      const va = a[campo] ?? '';
      const vb = b[campo] ?? '';
      const cmp = typeof va === 'number'
        ? va - vb
        : String(va).localeCompare(String(vb), 'es');
      return this.ascendenteElemento ? cmp : -cmp;
    });
  },
  },
watch: {
  filteredElementos()  { this.currentPage = 1; },
  filteredTarifario()  { this.currentPageTarifario = 1; },
  elementosOrdenados() { this.currentPage = 1; },
},
mounted() {
  this.idPerfil    = window.sessionStorage.getItem("idPerfil");
  this.idUsuario   = window.sessionStorage.getItem("idUsuario");
  this.verReportes = window.sessionStorage.getItem("verReportes");

  const key = this.p_idPlanilla;
  const get = (k) => localStorage.getItem(`${k}_${key}`);

  if (get('elementosPorPagina'))    this.elementosPorPagina    = Number(get('elementosPorPagina'));
  if (get('clasificacionBusqueda')) this.clasificacionBusqueda = get('clasificacionBusqueda');
  if (get('descripcionBusqueda'))   this.descripcionBusqueda   = get('descripcionBusqueda');
  if (get('codigoBusqueda'))        this.codigoBusqueda        = get('codigoBusqueda');
  if (get('nombreBusqueda'))        this.nombreBusqueda        = get('nombreBusqueda');
  if (get('paginaActual'))          this.paginaActual          = Number(get('paginaActual'));

  this.fetchDataWithFilters(this.paginaActual);
},
  beforeUnmount() {
    const modalElement = document.getElementById("ventanaModal");
    if (modalElement) {
      modalElement.removeEventListener("hidden.bs.modal", this.onModalHidden);
    }
  },
  methods: {
    getFormattedDate(date)    { return dateFormat.getFormattedDate(date); },
    getFormattedDateISO(date) { return dateFormat.getFormattedDateISO(date); },

    handleRowClick(event, idPlanillaDet) {
      if (event.target.tagName === "SELECT" || event.target.tagName === "OPTION") return;
      if (this.auditoriaMedica || this.supervisorGD || this.verReportes > 0) this.abrirModalEditar(idPlanillaDet);
    },
    handleAction(event, idPlanillaDet) {
      const action = event.target.value;
      if      (action === "editar")       this.abrirModalEditar(idPlanillaDet);
      else if (action === "observaciones") this.observaciones(idPlanillaDet, this.p_tipo);
      else if (action === "observacionesF") {
        this.planillaDetSeleccionada = idPlanillaDet;
        this.modalObsVisible = true;
      }
      else if (action === "borrar")       this.deletePlanillaDet(idPlanillaDet);
      event.target.value = "Seleccione...";
    },
    ordenarPorFechaYElemento(arr, fechaCampo, codigoCampo) {
      return arr.sort((a, b) => {
        const fa = new Date(a[fechaCampo]), fb = new Date(b[fechaCampo]);
        if (fa < fb) return 1; if (fa > fb) return -1;
        if (a[codigoCampo] < b[codigoCampo]) return -1;
        if (a[codigoCampo] > b[codigoCampo]) return 1;
        return 0;
      });
    },

    // ── Paginación ──────────────────────────────────────────────────
totalPaginas() {
  if (this.elementosPorPagina === -1) return 1;
  return Math.max(1, Math.ceil(this.planillaOrdenada.length / this.elementosPorPagina));
},
_aplicarSlice(noPagina) {
  this.paginaActual = noPagina;
  if (this.elementosPorPagina === -1 || this.elementosPorPagina === 100000000) {
    this.datosPaginados = this.planillaOrdenada;
  } else {
    const ini = (noPagina - 1) * this.elementosPorPagina;
    this.datosPaginados = this.planillaOrdenada
      .slice(ini, ini + this.elementosPorPagina);
  }
},
    getPreviousPage() {
      if (this.paginaActual > 1) this.fetchDataWithFilters(this.paginaActual - 1);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.fetchDataWithFilters(this.paginaActual + 1);
    },
    isActive(noPagina) { return noPagina === this.paginaActual ? "active" : ""; },

    // ── Carga de datos ──────────────────────────────────────────────
    fetchDataWithFilters(noPagina) {
      this.paginaActual = noPagina;
      localStorage.setItem(`paginaActual_${this.p_idPlanilla}`, noPagina);
      if      (this.descripcionBusqueda)   this.getDataDescripcion(noPagina);
      else if (this.nombreBusqueda)        this.getDataNombre(noPagina);
      else if (this.codigoBusqueda)        this.getDataCodigo(noPagina);
      else if (this.clasificacionBusqueda) this.getDataClasificacion(noPagina);
      else                                 this.getDataPaginaTodos(noPagina, 1);
    },
    _setData(data, noPagina) {
      this.planilladets = this.ordenarPorFechaYElemento(data, "fechaAtencion", "elementoCodigo");
      this._aplicarSlice(noPagina);
    },
    getDataDescripcion(noPagina) {
      if (!this.descripcionBusqueda) return;
      this.guardarFiltros();
      api.get(`/vwplanilladets/idplanilla-descripcion/${this.p_idPlanilla}/${this.descripcionBusqueda}`)
        .then(r => this._setData(r.data, noPagina));
    },
    getDataNombre(noPagina) {
      if (!this.nombreBusqueda) return;
      this.guardarFiltros();
      api.get(`/vwplanilladets/idplanilla-elementonombre/${this.p_idPlanilla}/${this.nombreBusqueda}`)
        .then(r => this._setData(r.data, noPagina));
    },
    getDataCodigo(noPagina) {
      if (!this.codigoBusqueda) return;
      this.guardarFiltros();
      api.get(`/vwplanilladets/idplanilla-codigo/${this.p_idPlanilla}/${this.codigoBusqueda}`)
        .then(r => this._setData(r.data, noPagina));
    },
    getDataClasificacion(noPagina) {
      if (!this.clasificacionBusqueda) return;
      this.guardarFiltros();
      localStorage.setItem(`clasificacionBusqueda_${this.p_idPlanilla}`, this.clasificacionBusqueda);
      api.get(`/vwplanilladets/idplanilla-clasificacion/${this.p_idPlanilla}/${this.clasificacionBusqueda}`)
        .then(r => this._setData(r.data, noPagina));
    },
getDataPaginaTodos(noPagina, aplicarFiltro) {
  this.descripcionBusqueda   = "";
  this.nombreBusqueda        = "";
  this.codigoBusqueda        = "";
  this.clasificacionBusqueda = "";
  if (aplicarFiltro === Number(0)) {
    // ── Limpiar todos los filtros guardados ──────────
    const key = this.p_idPlanilla;
    ['descripcionBusqueda', 'codigoBusqueda', 'nombreBusqueda',
     'clasificacionBusqueda', 'paginaActual', 'elementosPorPagina'
    ].forEach(k => localStorage.removeItem(`${k}_${key}`));
  }
  api.get(`/vwplanilladets/idplanilla-estado/${this.p_idPlanilla}/1`)
    .then(r => this._setData(r.data, noPagina));
},
    updateItemsPerPage() {
      this.elementosPorPagina = Number(this.elementosPorPagina);
      this.paginaActual = 1;
      localStorage.setItem(`elementosPorPagina_${this.p_idPlanilla}`, this.elementosPorPagina);
      localStorage.setItem(`paginaActual_${this.p_idPlanilla}`, 1);
      this.getDataPaginaTodos(1, 1);
    },

    // ── Validación ──────────────────────────────────────────────────
    validarForm() {
      return validarForm(this.datoPlanillaDet, ["idElemento","cantidad", "fechaAtencion"], ["Elemento","cantidad", "Fecha de Atención"]);
    },

    // ── CRUD ────────────────────────────────────────────────────────
    async guardarPlanillaDet() {
      if (this.validarForm() !== 1) return;
      if (this.datoPlanillaDet.cantidad <= 0) { swal("Error","La cantidad no puede ser ≤ 0","error"); return; }
      try {
        this.datoPlanillaDet.idPlanilla = this.p_idPlanilla;
        const now = new Date(), localDate = new Date(now.getTime() - 5*3600000);
        this.datoPlanillaDet.fechaReg = localDate.toISOString().split('.')[0];
        this.datoPlanillaDet.idUsuarioReg = this.idUsuario;
        this.datoPlanillaDet.descripcion = "Registrado por el equipo de planillaje";
        await api.post("/planilladets", this.datoPlanillaDet);
        this.modalInstance.hide(); this.modalWindow = false;
        swal("Correcto!", "Registro creado exitosamente!", "success");
        this.clasificacionBusqueda ? this.getDataClasificacion(this.paginaActual) : this.getDataPaginaTodos(this.paginaActual, 1);
      } catch { swal("Error!","Inténtelo de nuevo!","error"); }
    },
    async actualizarPlanillaDet() {
      if (this.validarForm() !== 1) return;
      if (this.datoPlanillaDet.cantidad <= 0) { swal("Error","La cantidad no puede ser ≤ 0","error"); return; }
      try {
        const now = new Date(), localDate = new Date(now.getTime() - 5*3600000);
        this.datoPlanillaDet.fechaAct = localDate.toISOString().split('.')[0];
        this.datoPlanillaDet.revisado = 1;
        this.datoPlanillaDet.idUsuarioAct = this.idUsuario;
        this.datoPlanillaDet.codigo       = this.datoPlanillaDet.codigo      || '.';
        this.datoPlanillaDet.descripcion  = this.datoPlanillaDet.descripcion || '.';
        await api.post("/planilladets", this.datoPlanillaDet);
        this.modalInstance.hide(); this.modalWindow = false;
        this.clasificacionBusqueda ? this.getDataClasificacion(this.paginaActual) : this.getDataPaginaTodos(this.paginaActual, 1);
        swal("Correcto!","Registro actualizado exitosamente!","success");
      } catch (error) {
        swal("Error!","Inténtelo de nuevo!","error");
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => swal(String(e)));
      }
    },
    async deletePlanillaDet(idPlanillaDet) {
      try {
        await api.delete("/planilladets/" + idPlanillaDet);
        this.clasificacionBusqueda ? this.getDataClasificacion(this.paginaActual) : this.getDataPaginaTodos(this.paginaActual, 1);
      } catch (error) { alert("No se pudo eliminar. " + error); }
    },

    // ── Modal ───────────────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow = true; this.datoPlanillaDet = {};
      this.titulo = "Crear"; this.btnCrear = true; this.btnEditar = false;
      this.searchTextElemento = "";
      this.$nextTick(() => {
        const el = document.getElementById("ventanaModal");
        if (el) {
          this.modalInstance = new bootstrap.Modal(el, { backdrop: true });
          this.modalInstance.show();
          el.addEventListener("hidden.bs.modal", this.onModalHidden);
        }
      });
    },
    async abrirModalEditar(idPlanillaDet) {
      this.modalWindow = true;
      if (idPlanillaDet != null) {
        await api.get("/vwplanilladets/" + idPlanillaDet).then(r => { this.datoPlanillaDet = r.data; });
        await this.fetchElementosPrestador();
      }
      this.titulo = "Editar"; this.btnCrear = false; this.btnEditar = true;
      if (this.datoPlanillaDet.fechaAtencion)
        this.datoPlanillaDet.fechaAtencion = this.getFormattedDateISO(this.datoPlanillaDet.fechaAtencion);
      this.$nextTick(() => {
        const el = document.getElementById("ventanaModal");
        if (el) {
          this.modalInstance = new bootstrap.Modal(el, { backdrop: true });
          this.modalInstance.show();
          el.addEventListener("hidden.bs.modal", this.onModalHidden);
        }
      });
    },
    onModalHidden() {
      this.modalWindow = false; this.datoPlanillaDet = {};
      this.titulo = ""; this.btnCrear = false; this.btnEditar = false;
      this.searchTextElemento = "";
      document.querySelectorAll(".modal-backdrop").forEach(el => el.remove());
      document.body.classList.remove("modal-open");
      document.body.style.paddingRight = "";
      if (this.modalInstance) { this.modalInstance.dispose(); this.modalInstance = null; }
    },

    // ── Fetch auxiliares ────────────────────────────────────────────
    async fetchElementosPrestador() {
      try {
        const r = await api.get(`/vwelemequis/idprestador-elemPresCodigo/${this.p_idPrestador}/${this.datoPlanillaDet.codigo}`);
        this.elementosPrestador = r.data;
      } catch (e) { console.error("Error al obtener elementos prestador:", e); }
    },
    async fetchElementos() {
      if (this.searchTextElemento.length < 2) { this.filteredElementos = []; return; }
      try {
        const r = await api.get(`/vwelementos/searchS3?search=${encodeURIComponent(this.searchTextElemento)}`);
        this.filteredElementos = r.data;
      } catch (e) { console.error("Error al obtener elementos:", e); }
    },
    debouncedFilterElementos() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.fetchElementos(), 300);
    },
    selectElemento(elemento) {
      this.datoPlanillaDet.idElemento    = elemento.idElemento;
      this.datoPlanillaDet.elementoNombre = elemento.nombre;
      this.datoPlanillaDet.elementoCodigo = elemento.codigo;
      this.searchTextElemento = elemento.nombre;
      this.filteredElementos = [];
    },
    async fetchTarifario() {
      if (this.searchTextTarifario.length < 2) { this.filteredTarifario = []; return; }
      try {
        const r = await api.get(`/vwtarifapress/search-prestador?idprestador=${this.p_idPrestador}&search=${encodeURIComponent(this.searchTextTarifario)}`);
        this.filteredTarifario = r.data;
      } catch (e) { console.error("Error al obtener tarifario:", e); }
    },
    debouncedFilterTarifario() {
      clearTimeout(this.debounceTimerTarifario);
      this.debounceTimerTarifario = setTimeout(() => this.fetchTarifario(), 300);
    },
    selectTarifario(tarifa) {
      this.datoPlanillaDet.idElemento    = tarifa.idElemento;
      this.datoPlanillaDet.elementoNombre = tarifa.elementoNombre;
      this.datoPlanillaDet.elementoCodigo = tarifa.elementoCodigo;
      this.datoPlanillaDet.valorUni      = tarifa.valor;
      this.searchTextTarifario = tarifa.elementoNombre;
      this.filteredTarifario = [];
    },
observaciones(idPlanillaDet, tipo) {
  if (!idPlanillaDet) return;
  const params = new URLSearchParams({
    idTramite:     this.p_idTramite,
    estadoTramite: this.p_estadoTramite,
    idPlanillaDet,
    tipo:          tipo || this.p_tipo,
    procesoAM:     this.p_procesoAM ? 1 : 0,
    tipoConsulta:  this.p_tipoConsulta,
  });
  this.$router.push(`/planilladet_pladetobs?${params.toString()}`);
},
    observacionesF(idPlanillaDet) {
      if (idPlanillaDet != null) {
        sessionStorage.setItem("observacionesData", JSON.stringify({
          idTramite:    this.p_idTramite,
          estadoTramite: this.p_estadoTramite,
          idPlanillaDet,
          tipo:         this.p_tipo,
          procesoAM:    this.p_procesoAM ? 1 : 0,
          tipoConsulta: this.p_tipoConsulta,
        }));
        this.$router.push("/planilladet_pladetobs");
      }
    },
    async actualizarFechaLab(idPlanilla, idPlanillaDet, fechaAtencion) {
      try {
        await api.post(`/procedimientos/actualizar-fecha?idPlanilla=${idPlanilla}&idPlanillaDet=${idPlanillaDet}&fechaAtencion=${this.getFormattedDateISO(fechaAtencion)}`);
        this.getDataPaginaTodos(this.paginaActual, 1);
      } catch (error) { alert("No se pudo actualizar. " + error); }
    },
    async actualizarRevision(planilladet, revisadoValor) {
      try {
        const now = new Date(), localDate = new Date(now.getTime() - 5*3600000);
        const actualizado = {
          ...planilladet,
          codigo:       planilladet.codigo       || '.',
          descripcion:  planilladet.descripcion  || '.',
          revisado:     revisadoValor == 1 ? 0 : 1,
          fechaAct:     localDate.toISOString().split('.')[0],
          idUsuarioAct: this.idUsuario
        };
        await api.post("/planilladets", actualizado);
        this.clasificacionBusqueda ? this.getDataClasificacion(this.paginaActual) : this.getDataPaginaTodos(this.paginaActual, 1);
      } catch (error) {
        swal("Error!","Inténtelo de nuevo!","error");
        Object.values(error.response?.data?.errors || {}).forEach(e => swal(String(e)));
      }
    },
    exportToCSV() {
      if (!this.planilladets.length) { Swal.fire({ title:"Advertencia", text:"No hay datos para exportar.", icon:"warning", confirmButtonText:"OK" }); return; }
      const headers = ["Fecha Atención","Código","Descripción","Cantidad","Valor Unitario","Valor"];
      const csv = ["\uFEFF" + headers.join(";"),
        ...this.planilladets.map(r =>
          [r.fechaAtencion||"", r.elementoCodigo||"", r.elementoNombre||"", r.cantidad||0, r.valorUni||0, (r.cantidad*r.valorUni)||0]
            .map(v => `"${v.toString().replace(/"/g,'""')}"`)
            .join(";"))
      ].join("\n");
      const link = document.createElement("a");
      link.href = URL.createObjectURL(new Blob([csv], { type:"text/csv;charset=utf-8;" }));
      link.download = `detalle_planilla_${this.p_idPlanilla}.csv`;
      link.style.visibility = "hidden";
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
    },
    exportToExcel() {
      if (!this.planilladets.length) { Swal.fire({ title:"Advertencia", text:"No hay datos para exportar.", icon:"warning", confirmButtonText:"OK" }); return; }
      const headers = ["Fecha Atención","Código","Descripción","Cantidad","Valor Unitario","Valor"];
      const data = this.planilladets.map(r => [r.fechaAtencion, r.elementoCodigo, r.elementoNombre, r.cantidad, r.valorUni, r.cantidad*r.valorUni]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Detalle");
      XLSX.writeFile(wb, `detalle_planilla_${this.p_idPlanilla}.xlsx`);
    },
guardarFiltros() {
  const key = this.p_idPlanilla;
  const campos = [
    'descripcionBusqueda',
    'codigoBusqueda',
    'nombreBusqueda',
    'clasificacionBusqueda',
    'paginaActual',
    'elementosPorPagina',
  ];
  campos.forEach(k => {
    const v = this[k];
    if (v !== null && v !== undefined && v !== '') {
      localStorage.setItem(`${k}_${key}`, v);
    } else {
      localStorage.removeItem(`${k}_${key}`);
    }
  });
},
    cerrarModal() {
      this.modalObsVisible = false;
      this.planillaDetSeleccionada = null;
    },
ordenarPor(campo) {
  if (this.campoOrden === campo) {
    this.ascendente = !this.ascendente;
  } else {
    this.campoOrden = campo;
    this.ascendente = true;
  }
  this._aplicarSlice(this.paginaActual);
},

iconOrden(campo) {
  if (this.campoOrden !== campo) return '⇅';
  return this.ascendente ? '↑' : '↓';
},
  toggleSeleccion(idPlanillaDet) {
    const idx = this.seleccionados.indexOf(idPlanillaDet);
    if (idx === -1) this.seleccionados.push(idPlanillaDet);
    else this.seleccionados.splice(idx, 1);
  },
  toggleSeleccionarTodos() {
    if (this.todosSeleccionadosEnPagina) {
      // Deseleccionar solo los de la página actual
      this.seleccionados = this.seleccionados.filter(
        id => !this.datosPaginados.some(p => p.idPlanillaDet === id)
      );
    } else {
      // Agregar los de la página actual sin duplicar
      const nuevos = this.datosPaginados
        .map(p => p.idPlanillaDet)
        .filter(id => !this.seleccionados.includes(id));
      this.seleccionados.push(...nuevos);
    }
  },
  async borrarSeleccionados() {
    if (!this.seleccionados.length) return;
    const confirmado = await Swal.fire({
      title: `¿Borrar ${this.seleccionados.length} registro(s)?`,
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, borrar",
      cancelButtonText: "Cancelar",
    });
    if (!confirmado.isConfirmed) return;

    try {
      const resultados = await Promise.allSettled(
        this.seleccionados.map(id => api.delete(`/planilladets/${id}`))
      );
      const fallidos = resultados.filter(r => r.status === "rejected").length;
      this.seleccionados = [];
      this.clasificacionBusqueda
        ? this.getDataClasificacion(this.paginaActual)
        : this.getDataPaginaTodos(this.paginaActual, 1);

      if (fallidos > 0) {
        Swal.fire("Atención", `${fallidos} registro(s) no se pudieron borrar.`, "warning");
      } else {
        Swal.fire("Correcto!", "Registros eliminados exitosamente.", "success");
      }
    } catch (error) {
      Swal.fire("Error!", "No se pudo completar el borrado. " + error, "error");
    }
  },
  ordenarPorElemento(campo) {
    if (this.campoOrdenElemento === campo) {
      this.ascendenteElemento = !this.ascendenteElemento;
    } else {
      this.campoOrdenElemento = campo;
      this.ascendenteElemento = true;
    }
  },
  iconOrdenElemento(campo) {
    if (this.campoOrdenElemento !== campo) return '⇅';
    return this.ascendenteElemento ? '↑' : '↓';
  },
  },
};
</script>

<style scoped>
/* ── Tabla ── */
.table-hover tbody tr {
  cursor: pointer;
}
.table-hover tbody tr:hover {
  background-color: #f5f5f5;
}
#sampleTable tr.table-warning td {
  background-color: #fff3cd !important;
}

/* ── Encabezados ordenables (heredado de Tramites) ── */
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
</style>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-contenido {
  width: 90%;
  max-width: 900px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}
</style>